// JS
import { toJS } from 'mobx';

// Bernie
import { ClientLogger } from 'bernie-client';
import { Controller, FetchOptions, Result } from 'bernie-core';

// Stores
import { AccountDataStateStore, UserAuthStore, ProgramStore } from 'stores';
import { AccountDataState } from 'stores/account-data-state-store';

// Logger
import AffiliateHubLogger from '../util/affiliate-hub-logger';

// tslint:disable-next-line
const wrapWithAccountDataController = (classRef: { new (): Controller }): { new (): Controller } => {
  class WithAccountDataController extends classRef {
    public async fetch(options: FetchOptions): Promise<Result> {
      if (options.isServer) {
        return Promise.resolve(Result.ok());
      }
      const logger = new AffiliateHubLogger(
        ClientLogger.getLoggerWithIdentifier(`controller.${WithAccountDataController.name}.${classRef.name}`),
      );

      const { stores, params, query } = options;
      const userAuthStore: UserAuthStore = stores?.get<UserAuthStore>('userAuth');
      const programStore: ProgramStore = stores?.get<ProgramStore>('programs');
      const accountDataStateStore: AccountDataStateStore = stores?.get<AccountDataStateStore>('accountDataStateStore');

      // re-initialize only when required
      if (accountDataStateStore.status !== AccountDataState.INITIALIZED) {
        accountDataStateStore.markAsPending();
        try {
          await userAuthStore.checkAuth();
          const programsPromise = userAuthStore.fetchUserProgramRelationships();
          const userDetailsPromise = userAuthStore.fetchUserDetails();
          await Promise.all([userDetailsPromise, programsPromise]);
          accountDataStateStore.markAsInitialized();
        } catch (e) {
          // 401 means user is not authenticated, this means data has been initialized - user is unauthorized.
          if (e?.errorCode === 401) {
            accountDataStateStore.markAsInitialized();
          } else {
            logger.error('FAILED_TO_FETCH_ACCOUNT_DATA', e);
            accountDataStateStore.markAsFailed();
          }
        }
      }

      return super.fetch(options);
    }
  }

  return WithAccountDataController;
};

export default wrapWithAccountDataController;
